import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import _ from 'lodash'

import InsolvencyOverview from './components/InsolvencyOverview'
import InsolvencyEvents from './components/InsolvencyEvents'
import InsolvencyReceivables from './components/InsolvencyReceivables'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class Insolvency extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        entity: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        locked: PropTypes.bool,
        module: PropTypes.string.isRequired,
    }

    render() {
        const { id, level, block, entity, module, locale, customData, locked } = this.props

        const entityCountry = entity.get('country', Map()).get('iso2', null)

        return (
            <div className={'ne-insolvency'}>
                <div>
                    <div className={'insolvency-overview-block'}>
                        <InsolvencyOverview
                            id={id}
                            level={level}
                            block={block}
                            module={module}
                            locale={locale}
                            customData={customData}
                            tableId={`ne-insolvency-overview-table-${id}`}
                            tableSelector={'insolvency'}
                            locked={locked}
                        />
                    </div>
                    <div className={'insolvency-events-block'}>
                        {!_.isEmpty(_.get(customData, `ne-insolvency-overview-table-${id}.data`, [])) && (
                            <InsolvencyEvents
                                id={id}
                                level={level}
                                block={block}
                                module={module}
                                locale={locale}
                                customData={customData}
                                tableId={`ne-insolvency-events-table-${id}`}
                                tableSelector={'events'}
                            />
                        )}
                    </div>
                    <div className={'insolvency-receivables-block'}>
                        {entityCountry !== 'SK' &&
                            !_.isEmpty(_.get(customData, `ne-insolvency-overview-table-${id}.data`, [])) && (
                                <InsolvencyReceivables
                                    id={id}
                                    level={level}
                                    block={block}
                                    module={module}
                                    locale={locale}
                                    customData={customData}
                                    tableId={`ne-insolvency-receivables-table-${id}`}
                                    tableSelector={'receivables'}
                                />
                            )}
                    </div>
                </div>
            </div>
        )
    }
}
